import { get } from './api'

const PREFIX = '/blade-portal/service-contact'

/** 展示位。目前只有报名成功页一处，后端按 scene 组织，将来复用到别处只需换这个值。 */
export const SCENE_BOOKING_SUCCESS = 'booking_success'

/**
 * 取某展示位当前生效的企微二维码。
 *
 * 失败或未配置一律返回 null —— 这一块是锦上添花不是关卡：
 * 运营还没传码、接口抖了、后端没发新版，都不该让报名成功页跟着出错。
 */
export async function getServiceContact(scene = SCENE_BOOKING_SUCCESS) {
  try {
    // api.js 的响应拦截器已经把 R 信封拆掉、直接返回 data，所以这里【不能】再取 .data
    const res = await get(`${PREFIX}/active`, { scene })
    // 后端未配置时返回 R.data(null)，BladeX 会把它序列化成 {} —— 是个 truthy 空对象，
    // 直接交给调用方会让 `contact ? A : B` 走错分支（副标题踩过），在这唯一入口归一成 null。
    return res && res.qrcodeImage ? res : null
  } catch {
    return null
  }
}
